import memoize from "lodash/memoize"
/**
 * Retrieves the enum wrapper object from the enum value from the 'serverReferences' global variable
 *
 * @param value an enum
 * @param enumValues the array of enum wrapper objects
 */

export const findEnumObject = memoize(<TEnum, TEnumDto extends { value: TEnum, text: string }>(
  value: TEnum, allDtos: TEnumDto[]) => allDtos.find((dto) => dto.value === value));

export const findEnumLabel = <TEnum, TEnumDto extends { value: TEnum, text: string }>(
  value: TEnum, allDtos: TEnumDto[]) => findEnumObject(value, allDtos)?.text;

export const getAgeRestriction = (value: server.dto.AgeRestrictions): server.dto.AgeRestriction => findEnumObject(value, serverReference.ageRestrictions);

export const getBankAccountFormat = (value: server.dto.BankAccountFormats): server.dto.BankAccountFormat => findEnumObject(value, serverReference.bankAccountFormats);

export const getCurrency = (value: server.dto.Currencies): server.dto.Currency => findEnumObject(value, serverReference.currencies);

export const getFinancialRiskLevel = (value: server.dto.FinancialRiskLevels): server.dto.FinancialRiskLevel => findEnumObject(value, serverReference.financialRiskLevels);

export const getRoomType = (value: server.dto.RoomTypes): server.dto.RoomType => findEnumObject(value, serverReference.roomTypes);

export const getBedType = (value: server.dto.BedTypes): server.dto.BedType => findEnumObject(value, serverReference.bedTypes);

export const getAppointmentPhase = (value: server.dto.AppointmentPhases): server.dto.AppointmentPhase => findEnumObject(value, serverReference.appointmentPhases);

export const getGroundTransportType = (value: server.dto.GroundTransportTypes): server.dto.GroundTransportType => findEnumObject(value, serverReference.groundTransportTypes);

export const getFlightTravelClass = (value: server.dto.FlightTravelClasses): server.dto.FlightTravelClass => findEnumObject(value, serverReference.flightTravelClasses);

export const getPickupLocationType = (value: server.dto.PickupLocationTypes): server.dto.PickupLocationType => findEnumObject(value, serverReference.pickupLocationTypes);

export const getPickupText = (type: server.dto.PickupLocationType, other: string): string => {
  return type.value === "other" ? other : type.text;
}

const lcidCultureMap = new Map<server.dto.LCID, server.dto.Culture>();
serverReference.templateCultures.forEach(c => lcidCultureMap.set(c.lcid, c));

export const getCultureFromLcid = (value: server.dto.LCID) => {
  return lcidCultureMap.get(value);
};